import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-238f92cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-pause"];
const _hoisted_2 = ["data-direction"];
const _hoisted_3 = {
  class: "am-chip"
};
const _hoisted_4 = {
  class: "am-chip"
};
const _hoisted_5 = {
  key: 0,
  class: "sr-only"
};
import { computed, onMounted, onBeforeUnmount, nextTick, reactive, ref, watch } from 'vue';
export default {
  __name: 'AlternatingMarquee',
  props: {
    /** 标签数据 */
    items: {
      type: Array,
      required: true
    },
    /** 行数 */
    rows: {
      type: Number,
      default: 3
    },
    /** 每行动画时长（秒），长度不足会循环取用 */
    durations: {
      type: Array,
      default: () => [26, 32, 29]
    },
    /** 行间距（px） */
    rowGap: {
      type: Number,
      default: 8
    },
    /** 标签间距（px） */
    gap: {
      type: Number,
      default: 12
    },
    /** 悬停暂停 */
    pauseOnHover: {
      type: Boolean,
      default: true
    },
    /** 边缘渐隐占比（0~0.5），0 关闭 */
    edgeFade: {
      type: Number,
      default: 0.08
    },
    /** 是否遵循系统“减少动效”偏好 */
    respectReducedMotion: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    const props = __props;

    /* 将 items 尽量平均拆分为多行 */
    const rowsData = computed(() => {
      const out = Array.from({
        length: props.rows
      }, () => []);
      props.items.forEach((it, i) => out[i % props.rows].push(it));
      return out;
    });

    /* 每行时长，循环读取 */
    const rowDurations = computed(() => rowsData.value.map((_, i) => props.durations[i % props.durations.length] ?? 28));

    /* 边缘渐隐样式 */
    const maskStyle = computed(() => {
      const p = Math.min(Math.max(props.edgeFade, 0), 0.5) * 100;
      if (p === 0) return {};
      const g = `linear-gradient(to right, transparent 0%, #000 ${p}%, #000 ${100 - p}%, transparent ${100}%)`;
      return {
        WebkitMaskImage: g,
        maskImage: g
      };
    });

    /* 内容不足一屏时禁用动画 */
    const noAnimateFlags = reactive([]); // 按行记录
    const wrappers = ref([]); // 每行外层
    const contents = ref([]); // 每行内容（单份）

    function setWrapperRef(el, idx) {
      if (el) wrappers.value[idx] = el;
    }
    function setContentRef(el, idx) {
      if (el) contents.value[idx] = el;
    }
    let resizeObs = null;
    function measureAll() {
      rowsData.value.forEach((_, i) => {
        const wrap = wrappers.value[i];
        const cont = contents.value[i];
        if (!wrap || !cont) return;
        noAnimateFlags[i] = cont.scrollWidth <= wrap.clientWidth;
      });
    }
    onMounted(async () => {
      await nextTick();
      measureAll();
      if ('ResizeObserver' in window) {
        resizeObs = new ResizeObserver(() => measureAll());
        wrappers.value.forEach(el => el && resizeObs.observe(el));
        contents.value.forEach(el => el && resizeObs.observe(el));
      } else {
        window.addEventListener('resize', measureAll);
      }
    });
    onBeforeUnmount(() => {
      if (resizeObs) {
        wrappers.value.forEach(el => el && resizeObs.unobserve(el));
        contents.value.forEach(el => el && resizeObs.unobserve(el));
        resizeObs.disconnect();
        resizeObs = null;
      } else {
        window.removeEventListener('resize', measureAll);
      }
    });
    watch([rowsData], async () => {
      await nextTick();
      measureAll();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "am-marquee",
        "data-pause": __props.pauseOnHover ? 'true' : 'false',
        style: _normalizeStyle(maskStyle.value),
        role: "marquee",
        "aria-live": "off"
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowsData.value, (row, idx) => {
        return _openBlock(), _createElementBlock("div", {
          key: idx,
          class: "am-row",
          style: _normalizeStyle({
            marginTop: idx === 0 ? '0px' : __props.rowGap + 'px',
            '--duration': rowDurations.value[idx] + 's'
          }),
          "data-direction": idx % 2 === 0 ? 'left' : 'right',
          ref_for: true,
          ref: el => setWrapperRef(el, idx)
        }, [_createElementVNode("div", {
          class: _normalizeClass(["am-track", {
            'no-animate': noAnimateFlags[idx]
          }])
        }, [_createElementVNode("div", {
          class: "am-content",
          ref_for: true,
          ref: el => setContentRef(el, idx),
          style: _normalizeStyle({
            '--gap': __props.gap + 'px'
          })
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (it, i) => {
          return _renderSlot(_ctx.$slots, "item", {
            key: i,
            item: it,
            index: i
          }, () => [_createElementVNode("span", _hoisted_3, _toDisplayString(typeof it === 'object' ? JSON.stringify(it) : it), 1)]);
        }), 128))], 4), _createElementVNode("div", {
          class: "am-content",
          "aria-hidden": "true",
          style: _normalizeStyle({
            '--gap': __props.gap + 'px'
          })
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (it, i) => {
          return _renderSlot(_ctx.$slots, "item", {
            key: 'dup-' + i,
            item: it,
            index: i
          }, () => [_createElementVNode("span", _hoisted_4, _toDisplayString(typeof it === 'object' ? JSON.stringify(it) : it), 1)]);
        }), 128))], 4)], 2)], 12, _hoisted_2);
      }), 128)), __props.respectReducedMotion ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 如果系统设置了“减少动态效果”，滚动将被禁用。 ")) : _createCommentVNode("", true)], 12, _hoisted_1);
    };
  }
};